import * as React from 'react';

import BannersTable from './BannersTable';
import { withRouter } from 'react-router';

class Banners extends React.Component {
  state = {
    loading: false,
    status: 'pending',
    searchQuery: ''
  };

  constructor(props: any) {
    super(props);
  }

  public render() {
    return (
      <div>
        <BannersTable domain={(this.props as any).match.params.eshop}/>
      </div>
    );
  }
}

export default withRouter(Banners)


// WEBPACK FOOTER //
// ./src/scenes/Banners/index.tsx